<div
  routerLink="/raffles"
  class="group relative flex h-[17.5rem] h-full w-full max-w-[59.6rem] cursor-pointer items-start justify-start overflow-hidden rounded-[2.4rem] bg-[#E37710] p-[2.4rem] !pr-0 custom-transition-all hover:bg-[#F58922] lg:h-[13rem] lg:max-w-full lg:rounded-[1.4rem] lg:p-[1.4rem]"
>
  <div class="z-[2] flex items-start justify-start space-x-[0.4rem] lg:space-x-[0.6rem] lg:p-[0.2rem]">
    <span
      i18n="@@main.raffle"
      class="text-[1.8rem] font-450 leading-[2.4rem] text-white sm:leading-[2.2rem] lg:text-[1.5rem]"
      >Розыгрыши</span
    >
    @if (rafflesState.rafflesList().length) {
      <div
        class="flex h-[2.4rem] w-[2.4rem] items-center justify-center rounded-[1.4rem] bg-[#F92529] lg:h-[2rem] lg:w-[2rem]"
      >
        <span class="text-[1.3rem] font-400 leading-[1.2rem] text-white lg:text-[1.1rem]">{{
          rafflesState.rafflesList().length
        }}</span>
      </div>
    }
  </div>

  <div
    class="mask scrollbar-hide relative ml-[1.5rem] pl-[3.5rem] flex h-full flex-1 items-center justify-start overflow-auto lg:ml-[0.5rem] lg:pl-[1.3rem]"
  >
    <swiper class="slider__content !pr-[1.6rem] lg:!pr-[3.2rem] flex items-center justify-center w-full h-full pr-[2.4rem] sm:pr-[1.4rem]"
      [config]="{
        slidesPerView: 'auto',
    }"
      #swiperRef
    >
        @for (raffle of rafflesState.rafflesList(); track raffle?.id) {
          <ng-template swiperSlide>
            <raffle-item-banner [info]="raffle" />
          </ng-template>
        }
    </swiper>
  </div>
  <img
    loading="lazy"
    fetchpriority="low"
    class="pointer-events-none absolute bottom-0 left-0 z-[1] h-full max-h-full w-auto custom-transition-all group-hover:translate-x-[1.6rem] group-hover:translate-y-[0.6rem] group-hover:scale-[1.14] lg:h-[95%] ticket-img"
    src="/assets/images/main/raffles/ticket.png"
    alt=""
  />
  <img
    loading="lazy"
    fetchpriority="low"
    class="pointer-events-none absolute bottom-0 right-0 z-[3] h-full max-h-full w-auto"
    src="/assets/images/main/raffles/right-shadow.png"
    alt=""
  />
</div>
